import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAuthArrowPattern = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 343,
	height: 220,
	viewBox: "0 0 343 220",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M16.0558 69.153L49.7845 104.646M16.0558 69.153L6.31362 117.355M16.0558 69.153C49.0601 208.449 100.443 221.95 139.325 209.339C176.675 197.238 190.343 131.392 214.943 84.7674C256.431 6.14356 281.759 -0.4956 336.638 11.4985",
		stroke: "#06B14D",
		strokeWidth: 12,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgAuthArrowPattern);
export { ForwardRef as ReactComponent };
